// src/components/DictionnairePage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { dictionaryService, userService } from "../../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileWord,
  faVolumeUp,
  faChevronDown,
  faExchangeAlt,
  faUserCircle,
  faCommentDots,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import "../../styles/DictionnairePage.css";
import SearchSelect from "./SearchBar";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";
// Import de l'image
import algerieImage from "../../assets/Algerie.png";

export default function DictionnairePage() {
  // const entryId = 1; // à remplacer par l'id dynamique
  const { currentUser } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [entry, setEntry] = useState(null);
  const [wordsList, setWordsList] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
      return;
    }
    dictionaryService
      .getEntry(id)
      .then((res) => {
        setEntry(res.data);
      })
      .catch((err) => {
        console.error("Error fetching entry:", err);
      });
    dictionaryService
      .getAllEntries({ ordering: "mot" })
      .then((res) => {
        console.log("get suggest : ", res.data);
        setWordsList(res.data.results);
      })
      .catch((err) => {
        console.error("Error fetching entry:", err);
      });
    dictionaryService
      .getCommentsByEntry(id)
      .then((res) => {
        console.log("get comments : ", res.data);
        setComments(res.data.results || res.data);
      })
      .catch((err) => {
        console.error("Error fetching entry:", err);
      });
    userService
      .getCurrentUser()
      .then((res) => setUser(res.data))
      .catch((err) => {
        console.error("Error fetching entry:", err);
      });
  }, [id]);

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    if (!currentUser) {
      alert("Vous devez être connecté pour ajouter un commentaire.");
      return;
    }
    dictionaryService
      .addComment({
        entry_id : id,
        comment: newComment,
      })
      .then((res) => {
        setComments([...comments, res.data]);
        setNewComment("");
      });
  };

  useEffect(() => {
    if (currentUser) {
      setIsAdmin(currentUser.profile.role === "admin");
      console.log(`Current user role: ${currentUser.profile.role}`);
    }
  }, [currentUser]);

  if (!entry) {
    return <div className="dict-bg">Loading...</div>;
  } else {
    // Check if the entry is pending and the user is an admin
    if (entry.status === "pending" && !isAdmin) {
      navigate("/dictionary");
    }
  }
  return (
    <div className="dict-bg">
      {/* Admin buttons positioned absolutely */}

      {/* Search bar section */}
      <div className="dict-search-section">
        <div className="search-container">
          <SearchSelect
            placeholder="Rechercher un terme..."
            fetchItems={async (searchIteam) => {
              const params = {
                page: 1,
                q: searchIteam,
              };
              console.log("Fetching items with params:", params);
              const results = await dictionaryService.getAllEntries(params);
              console.log("Results:", results);
              if (results.status !== 200) {
                console.error("Error fetching data:", results);
                return [];
              }
              return results.data.results;
            }}
            onSelect={(item) => {
              console.log("Selected item:", item);
              navigate(`/dictionary/${item.id}`);
            }}
          />
        </div>
      </div>

      <main className="dict-content">
        <div className="dict-main-left">
          {/* Status indicator */}
          <div className="status-indicator">{entry.status}</div>
          {isAdmin && entry.status === "pending" && (
            <div className="">
              <div className="admin-buttons">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    dictionaryService
                      .validateEntry(id)
                      .then(() => {
                        window.location.reload();
                      })
                      .catch((err) => console.error("Erreur validation:", err));
                  }}
                >
                  Valider le projet
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    dictionaryService
                      .deleteEntry(id)
                      .then(() => {
                        navigate("/Admin/dictionary/");
                      })
                      .catch((err) => console.error("Erreur rejet:", err));
                  }}
                >
                  Rejeter le projet
                </button>
              </div>
            </div>
          )}
          {/* Bloc TERME */}
          <section className="dict-bloc dict-terme">
            <div className="dict-bloc-title">
              <FontAwesomeIcon icon={faFileWord} className="icon-terme" />
              TERMES
            </div>
            {entry && (
              <>
                <div className="dict-terme-word">
                  <span className="dict-terme-audio">
                    <FontAwesomeIcon icon={faVolumeUp} className="icon-audio" />
                  </span>
                  <span className="dict-terme-mot">{entry.word}</span>
                  <span className="dict-terme-trad">{entry.translation}</span>
                  <span className="dict-terme-type">{entry.word_type}</span>
                </div>
                <div className="dict-terme-def">{entry.signification}</div>
                <div className="dict-terme-ar">{entry.arabic_word}</div>
                <div className="dict-terme-ar">
                  {entry.details?.word_ar_msa ? `الفصحى: ${entry.details.word_ar_msa}` : ""}
                </div>
                <div className="dict-terme-ex">
                  <span className="dict-terme-ex-label">EX :</span>
                  <span className="dict-terme-ex-content">
                    {entry.details.example}
                  </span>
                </div>
              </>
            )}
          </section>

          {/* Bouton contribuer après le container du mot */}
          <div className="contribute-section">
            <a className="contribute-btn" href="/dictionary/add">
              Contribuer
            </a>
          </div>

          {/* Bloc COMMENTAIRES */}
          <section className="dict-bloc dict-comments">
            <div className="dict-bloc-title">
              <FontAwesomeIcon icon={faCommentDots} className="icon-comment" />
              COMMENTAIRES
            </div>
            <div className="dict-comments-list">
              {comments.map((c) => (
                <div key={c.id} className="dict-comment">
                  <div className="dict-comment-avatar">
                    <FontAwesomeIcon
                      icon={faUserCircle}
                      className="icon-user"
                    />
                  </div>
                  <div className="dict-comment-content">
                    <span className="dict-comment-user">
                      {c.user_username || c.user}
                    </span>
                    <span className="dict-comment-text">{c.comment}</span>
                  </div>
                </div>
              ))}
              <div className="dict-comments-more">
                Afficher plus <FontAwesomeIcon icon={faChevronDown} />
              </div>
            </div>
            <form className="dict-comment-form" onSubmit={handleCommentSubmit}>
              <div className="dict-comment-avatar">
                <FontAwesomeIcon icon={faUserCircle} className="icon-user" />
              </div>
              <input
                type="text"
                value={newComment}
                placeholder="Ajouter un commentaire à propos de ce terme..."
                onChange={(e) => setNewComment(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleCommentSubmit(e);
                  }
                }}
              />
              <button type="submit" className="comment-submit-btn">
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </form>
          </section>
        </div>

        {/* Bloc DROIT : liste alphabétique */}
        <aside className="dict-main-right">
          <div className="dict-right-title">
            Français{" "}
            <FontAwesomeIcon icon={faExchangeAlt} className="icon-exchange" />{" "}
            Darija
          </div>
          <ul className="dict-right-list">
            {wordsList.map((w) => (
              <li key={w.id}>
                <a href={`/dictionary/${w.id}`}>
                  <div>
                    <div>{w.word}</div>
                    <div>{w.arabic_word}</div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
          <div className="dict-right-more">
            Afficher plus <FontAwesomeIcon icon={faChevronDown} />
          </div>
        </aside>
      </main>

      <section className="dict-bottom-bloc">
        <div className="dict-bottom-text">
          <span className="dict-bottom-title">
            Notre langue, notre identité !
          </span>
          <br />
          Contribuez à préserver le patrimoine algérien en partageant vos mots
          et expressions. Ensemble, gardons notre culture vivante !
          <br />
          <a href="/DictionnaryForm" className="dict-bottom-link">
            Contribuer Maintenant
          </a>
        </div>
        <div className="dict-bottom-img">
          <img src={algerieImage} alt="Carte Algérie" />
        </div>
      </section>
    </div>
  );
}
